import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableReportsDashboard = Loadable({
  loader: function loader() {
    return import('../ReportsDashboard.jsx');
  },
  loading: ComponentLoading
});
export default LoadableReportsDashboard;